import * as apiClient from '../../services/api-client';

export const parseUrl = async (store, url) => {
    const responseData = await apiClient.giftlist.getParsedUrl(url, store.state.auth.cla_token);
    const response = {
        type: "parseurl",
        data: responseData
    };
    store.setState({ response });
};

export const addItem = async (store, itemData) => {
    let responseData = await apiClient.giftlist.addItem(itemData, store.state.auth.cla_token);
    responseData.claims =[];
    if(itemData.userID === store.state.user.userID) {
        let mygiftlist = [
            ...store.state.mygiftlist,
            responseData
        ];
        store.setState({ mygiftlist });
    } else {
        let activeGiftlist = {
            ...store.state.activeGiftlist,
            giftlist: [
                ...store.state.activeGiftlist.giftlist,
                responseData
            ]
        };
        store.setState({ activeGiftlist });
    }
    const response = {
        type: "additem",
        data: responseData
    };
    store.setState({ response });
};

export const addArchivedItem = async (store, data) => {
    const responseData = await apiClient.giftlist.copyItem(data, store.state.auth.cla_token);
    if(data.userID === store.state.user.userID) {
        let mygiftlist = [
            ...store.state.mygiftlist,
            responseData
        ];
        store.setState({ mygiftlist });
    } else {
        let activeGiftlist = {
            ...store.state.activeGiftlist,
            giftlist: [
                ...store.state.activeGiftlist.giftlist,
                responseData
            ]
        };
        store.setState({ activeGiftlist });
    }
    const response = {
        type: "addarchiveditem",
        data: responseData
    };
    store.setState({ response });
};

export const updateItem = async (store, itemData) => {
    const responseData = await apiClient.giftlist.updateItem(itemData, store.state.auth.cla_token);
    if(itemData.userID === store.state.user.userID) {
        let idx = store.state.mygiftlist.map(gl => gl.itemID).indexOf(itemData.itemID);
        console.log('FOUND INDEX', idx, store.state.mygiftlist);
        if(idx >= 0) {
            let mygiftlist = [
                ...store.state.mygiftlist.slice(0, idx),
                {
                    ...store.state.mygiftlist[idx],
                    ...responseData
                },
                ...store.state.mygiftlist.slice(idx+1)
            ];
            store.setState({ mygiftlist });
        }
    } else {
        let idx = store.state.activeGiftlist.giftlist.map(gl => gl.itemID).indexOf(itemData.itemID);
        if(idx >= 0) {
            let giftlist = [
                ...store.state.activeGiftlist.giftlist.slice(0, idx),
                {
                    ...store.state.activeGiftlist.giftlist[idx],
                    ...responseData
                },
                ...store.state.activeGiftlist.giftlist.slice(idx+1)
            ];
            let activeGiftlist = {
                ...store.state.activeGiftlist,
                giftlist: giftlist
            }
            store.setState({ activeGiftlist });
        }
    }

    const response = {
        type: "updateitem",
        data: responseData
    };
    store.setState({ response });
};

export const removeItem = async (store, itemID) => {
    const responseData = await apiClient.giftlist.removeItem(itemID, store.state.auth.cla_token);
    //remove from my or active list
    let idx = store.state.activeGiftlist.giftlist.map(gl => gl.itemID).indexOf(itemID);
    if(idx >= 0) {
        let giftlist = [
            ...store.state.activeGiftlist.giftlist.slice(0, idx),
            ...store.state.activeGiftlist.giftlist.slice(idx+1)
        ];
        let activeGiftlist = {
            ...store.state.activeGiftlist,
            giftlist: giftlist
        }
        store.setState({ activeGiftlist });
    } else {
        idx = store.state.mygiftlist.map(gl => gl.itemID).indexOf(itemID);
        if(idx >= 0) {
            let mygiftlist = [
                ...store.state.mygiftlist.slice(0, idx),
                ...store.state.mygiftlist.slice(idx+1)
            ];
            store.setState({ mygiftlist });
        }
    }

    const response = {
        type: "removeitem",
        data: responseData
    };

    store.setState({ response });
};